<template>
  <div class="home">
    <div class="home_container">
      <h1 class="bold color-00897b tac">你家耐震嗎?</h1>
      <h5 class="bold">《聯合報》整理了5個耐震檢測項目，讓你檢視自家房屋安全。</h5>
      <h6>此檢測僅提供初步判斷，若需進一步確認房屋結構耐震安全，請找專業技師評估。</h6>
      <div class="home_container_btns tac">
        <router-link to="/question1" class="home_container_btn" title="開始檢測" @click.native="click_GA">開始檢測</router-link>
      </div>
    </div>
    <div class="home_bg_bottom"></div>
    <div class="home_bg_car1"></div>
    <div class="home_bg_car2"></div>
    <div class="home_bg_top"></div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    bar: Object
  },
  computed: {
    isWeb(){
      if(window.innerWidth >= 768){
        return true
      }
      return false
    }
  },
  methods: {
    detectPlatform() {
      if( navigator.userAgent.match(/Android/i)
          || navigator.userAgent.match(/webOS/i)
          || navigator.userAgent.match(/iPhone/i)
          || navigator.userAgent.match(/iPad/i)
          || navigator.userAgent.match(/iPod/i)
          || navigator.userAgent.match(/BlackBerry/i)
          || navigator.userAgent.match(/Windows Phone/i)
      ){
          return 'Mob';
      }
      else {
          return 'PC';
      }
    },
    click_GA() {
      ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'Start',
        eventAction: 'Click',
        eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [button]`,
      });
    }
  },
  mounted() {
    if(this.bar){
      this.bar._container.parentNode.style.opacity = 0
    }
    document.querySelector('.topBar').style.background = 'transparent'

    const tl = new TimelineMax()
    if(window.innerWidth>=768) {
      const car01 = document.querySelector('.home_bg_car1')
      const car02 = document.querySelector('.home_bg_car2')

      TweenMax.fromTo(car01, 10, {x:0, y:0}, {x:1300, y:-570, ease: Power0.easeNone, repeat: -1})
      TweenMax.fromTo(car02, 10, {x:0, y:0}, {x:-1100, y:500, ease: Power0.easeNone, repeat: -1})
    }else {
      const car01 = document.querySelector('.home_bg_car1')
      TweenMax.fromTo(car01, 7, {x:0, y:0}, {x:-200, y:90, ease: Power0.easeNone, repeat: -1});
    }
  },
  destroyed() {
    if(!this.isWeb){
      document.querySelector('.topBar').style.background = '#5B5B5B'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
h1, h5, h6
  margin-bottom: 1rem
.bold
  font-weight: bold
.tac
  text-align: center
.home
  position: relative
  margin: 0 auto
  width: 100%
  height: 100vh
  display: flex
  align-items: center
  overflow: hidden
.home_container
  position: relative
  z-index: 5
  margin: 0 auto
  padding: 2rem
  width: 100%
  background: rgba(255,255,255,.9)
  // text-align: center
  @media (min-width: 768px) and (max-width: 1279.98px) 
    text-align: left
    width: 500px
  @media (min-width: 1280px) 
    text-align: left
    width: 500px
.color-00897b
  color: #00897b
.home_container_btn
  display: inline-block
  padding: 1rem 2rem
  background-color: #57af9f
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16)
  font-size: 21px
  color: #fff
  text-decoration: none
.home_container_btns
  @media (min-width: 768px) 
    text-align: right
.home_bg_bottom, .home_bg_top, .home_bg_car1, .home_bg_car2
  position: absolute
  left: 0
  top: 0
.home_bg_bottom
  width: 100%
  height: 100vh
  background-image: url('../../public/static/image/cover/mob_bottom.jpg')
  background-size: cover
  @media (min-width: 768px)
    background-image: url('../../public/static/image/cover/web_bottom.jpg')
    background-size: 100%
.home_bg_car1
  width: 100%
  height: 100vh
  background-image: url('../../public/static/image/cover/mob_car.svg')
  background-size: cover
  @media (min-width: 768px)
    background-image: url('../../public/static/image/cover/web_car01.svg')
    background-size: 100%
.home_bg_car2
  width: 100%
  height: 100vh
  @media (min-width: 768px)
    background-image: url('../../public/static/image/cover/web_car02.svg')
    background-size: 100%
.home_bg_top
  width: 100%
  height: 100vh
  background-image: url('../../public/static/image/cover/mob_top.png')
  background-size: cover
  @media (min-width: 768px)
    background-image: url('../../public/static/image/cover/web_top.png')
    background-size: 100%
</style>
